import React from 'react';

/**
 * APEX Design System — Button
 *
 * Variants:
 *   - primary  : bouton principal (gradient cyan→fuchsia)
 *   - secondary: bouton secondaire (border zinc-800)
 *   - ghost    : bouton transparent (texte uniquement)
 *   - danger   : bouton danger (rouge/rose)
 *
 * Sizes:
 *   - sm  : 32px height, text-xs
 *   - md  : 40px height, text-sm (défaut)
 *   - lg  : 48px height, text-base
 *
 * Usage:
 *   <Button variant="primary" onClick={...}>ON Y VA</Button>
 *   <Button variant="secondary" size="sm">Annuler</Button>
 */

const VARIANTS = {
  primary: 'bg-gradient-to-r from-cyan-400 to-fuchsia-400 text-black hover:opacity-90 font-black',
  secondary: 'border border-zinc-800 text-zinc-300 hover:border-zinc-700 hover:bg-zinc-900 font-bold',
  ghost: 'text-zinc-400 hover:text-white font-semibold',
  danger: 'border border-rose-400 text-rose-400 hover:bg-rose-400/10 font-bold'
};

const SIZES = {
  sm: 'px-3 py-1.5 text-xs',
  md: 'px-4 py-2.5 text-sm',
  lg: 'px-5 py-3 text-base'
};

export default function Button({
  children,
  variant = 'secondary',
  size = 'md',
  disabled = false,
  loading = false,
  type = 'button',
  className = '',
  onClick,
  ...rest
}) {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled || loading}
      className={`
        ${VARIANTS[variant]}
        ${SIZES[size]}
        tracking-wider
        transition
        disabled:opacity-40
        disabled:cursor-not-allowed
        ${className}
      `}
      {...rest}
    >
      {loading ? '...' : children}
    </button>
  );
}
